import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CalendarClock, CheckCircle2, ListPlus } from "lucide-react";
import { toast } from "sonner";

export function GrowthActions({ actions, selected, readOnly, scheduleUrl, scheduleLabel, onAdded, ryder }) {
  const [pick, setPick] = useState([]);
  const [busy, setBusy] = useState(false);
  const entries = Object.entries(actions).filter(([k]) => ryder || !k.startsWith("sys_") || k === "sys_lead_owners");
  const toggle = (k) => setPick(pick.includes(k) ? pick.filter((x) => x !== k) : pick.length < 5 ? [...pick, k] : pick);
  const add = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/prime/my-growth/actions", { keys: pick });
      toast.success(`${data.created.length} added to My Tasks${data.skipped.length ? ` · ${data.skipped.length} already there` : ""}`); setPick([]); onAdded();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-5 sm:p-6" data-testid="growth-actions">
      <h2 className="font-display text-base md:text-lg font-bold text-slate-900">Turn guidance into action</h2>
      <p className="text-sm text-slate-600">Choose up to five <b>optional agency growth actions</b> to add to My Tasks. They aren't program requirements, and they don't change your verified progress or your Prime Score.</p>
      <ul className="mt-3 grid md:grid-cols-2 gap-2">
        {entries.map(([k, a]) => {
          const done = selected.includes(k);
          return (
            <li key={k}><label className={`flex items-start gap-2 rounded-xl border px-3 py-2 text-sm ${done ? "border-emerald-200 bg-emerald-50 text-emerald-800" : pick.includes(k) ? "border-[#006090] bg-[#006090]/5" : "border-slate-200"}`}>
              {done ? <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" /> : <input type="checkbox" className="mt-1" checked={pick.includes(k)} disabled={readOnly} onChange={() => toggle(k)} data-testid={`growth-action-${k}`} />}
              <span><b className="font-medium">{a.title}</b>{done && <span className="block text-[11px]">Already in My Tasks</span>}</span></label></li>);
        })}
      </ul>
      <div className="mt-4 flex flex-wrap gap-2 items-center">
        <Button onClick={add} disabled={readOnly || busy || !pick.length} className="bg-brand hover:bg-brand-strong" data-testid="growth-add-actions"><ListPlus className="w-4 h-4 mr-1.5" />Add {pick.length || ""} to My Tasks</Button>
        {scheduleUrl && <a href={scheduleUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-2 text-sm font-medium hover:bg-slate-50" data-testid="growth-schedule-review"><CalendarClock className="w-4 h-4 text-[#006090]" />Schedule a growth review{scheduleLabel ? ` — ${scheduleLabel}` : ""}</a>}
        {readOnly && <span className="text-xs text-slate-500" data-testid="growth-readonly">View As is read-only.</span>}
      </div>
    </section>
  );
}
